
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/events/[event-id]",
      function () {
        return require("private-next-pages/next/events/[event-id].tsx");
      }
    ]);
  